import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/spm-ui-upgrade-helper/spm-ui-upgrade-helper/packages/gatsby-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This information is intended for general guidance only. It is not intended to be a substitute for detailed research or the exercise of professional judgment.
Merative shall not be responsible for any loss whatsoever sustained by any organization or person who relies on this material.`}</p>
    <p>{`THE INFORMATION IN THIS DOCUMENT IS PROVIDED “AS IS” WITHOUT ANY WARRANTY, EXPRESS OR IMPLIED, INCLUDING WITHOUT ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND ANY WARRANTY OR CONDITION OF NON-INFRINGEMENT.`}</p>
    <h2>{`Trademarks`}</h2>
    <p>{`Merative and the Merative logo are trademarks of Merative US L.P. in the United States and other countries. Other product and service names may be trademarks of Merative or other companies.`}</p>
    <p>{`IBM, the IBM logo, and ibm.com are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide.`}</p>
    <p>{`Adobe™, the Adobe logo, PostScript™, and the PostScript logo are either registered trademarks or trademarks of Adobe Systems Incorporated in the United States, and/or other countries.`}</p>
    <p>{`Oracle and Java are registered trademarks of Oracle and/or its affiliates.`}</p>
    <p>{`The registered trademark Linux® is used pursuant to a sublicense from the Linux Foundation, the exclusive licensee of Linus Torvalds, owner of the mark on a world­wide basis.`}</p>
    <p>{`Microsoft™, Windows™, and the Windows logo are trademarks of Microsoft Corporation in the United States, other countries, or both.`}</p>
    <p>{`UNIX™ is a registered trademark of The Open Group in the United States and other countries.`}</p>
    <p>{`Other company, product, and service names may be trademarks or service marks of others.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      